// extracted by css-extract-rspack-plugin
export default {"avatar":"pXwB_","placeholder":"jAGh2","img":"UgTmm"};